import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from 'react-bootstrap';
import { formatDateTime } from 'services/utils';
import i18nContext from 'components/i18n-context';
import './LogsTabTableRow.scss';

export const LogsTabTableRow = ({ isLoading, logsTabData }) => {
  const i18n = useContext(i18nContext);

  const getDateAndTimeRow = (logDate) => {
    const date = formatDateTime(logDate);

    return <i className={'logsTab-table-cell-info-date'}>{date}</i>;
  };

  const getLogsTabInfoBlock = (logsTabBlockInfo) => {
    if (isLoading) {
      return (
        <Placeholder as='p' animation='glow'>
          <Placeholder className={'logs-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else {
      return <p>{logsTabBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'logs-table-cell'}>
        <div className={'logs-table-cell-info'}>
          {getLogsTabInfoBlock(logsTabData?.author)}
          <div className={'logs-table-cell-info-date'}>
            {getLogsTabInfoBlock(getDateAndTimeRow(logsTabData?.createdAt))}
          </div>
        </div>
      </td>
      <td className={'logs-table-cell'}>{getLogsTabInfoBlock(logsTabData?.action)}</td>
      <td className={'logs-table-cell'}>
        {logsTabData?.changes && Array.isArray(logsTabData.changes) ? (
          <div>
            {logsTabData.changes.map((change, index) => (
              <div key={index} style={{ marginBottom: '8px' }}>
                <div>
                  <strong>
                    {index + 1}. {change.name}
                  </strong>
                </div>
                <div>{`${change.before ? change.before : 'Not Set'} -> ${change.after}`}</div>
              </div>
            ))}
          </div>
        ) : (
          `${logsTabData?.changes?.before ? logsTabData?.changes?.before : 'Not Set'} -> ${logsTabData?.changes?.after}`
        )}
      </td>
    </tr>
  );
};

LogsTabTableRow.propTypes = {
  isLoading: PropTypes.bool,
  logsTabData: PropTypes.shape({
    account_number: PropTypes.string,
    createdAt: PropTypes.string,
    author: PropTypes.string,
    action: PropTypes.string,
    changes: PropTypes.arrayOf(
      PropTypes.shape({
        after: PropTypes.string,
        before: PropTypes.string,
        name: PropTypes.string
      })
    )
  })
};
